module.exports = __webpack_public_path__ + "img/2.53b5fd2f.png";